import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[ravOnlyNumbers]'
})
export class OnlyNumbersDirective {
  allowedKeys: Array<string> = [
    'Backspace',
    'Delete',
    'Escape',
    'Enter',
    'Home',
    'End',
    'ArrowLeft',
    'ArrowRight',
    'Clear',
    'Copy',
    'Paste',
    'Tab'
  ];

  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(e: KeyboardEvent): void {
    if (
      this.allowedKeys.indexOf(e.key) > -1 ||
      (e.key === 'c' && (e.ctrlKey || e.metaKey)) ||
      (e.key === 'v' && (e.ctrlKey || e.metaKey)) ||
      (e.key === 'x' && (e.ctrlKey || e.metaKey)) ||
      e.ctrlKey ||
      e.metaKey ||
      e.code === 'Space'
    ) {
      return; // don't do anything
    }

    if (e.key === ' ' || e.key === '' || isNaN(Number(e.key))) {
      e.preventDefault();
    }
  }
}
